<template>
	<div :class="['sk-navigation-link__icon-wrapper', {'active': isActive}]">
		<img @click="actionGoTo" class="sk-navigation-link__icon" :src="`/static/svg/${icon}`" :title="title" :alt="title">
		<div v-if="count > 0" class="label">{{ count }}</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'navigation-link',
	props: {
		route: {
			type: String,
			default: null
		},
		routeStartsWith: {
			type: String,
			default: null
		},
		title: {
			type: String,
			default: null
		},
		icon: {
			type: String,
			default: 'idicare'
		},
		count: {
			type: Number,
			default: 0
		}
	},
	methods: {
		actionGoTo() {
			if (!this.route)
				return

			this.$root.$emit('navigation-close')

			this.$router.push({
				name: this.route,
				params: {
					user_uid: this.currentUser.uid
				}
			})
		}
	},
	computed: {
		isActive() {
			if (this.routeStartsWith) {
				return this.$route.name.startsWith(this.routeStartsWith)
			}
			return this.route === this.$route.name
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style scoped>
	.sk-navigation-link__icon-wrapper {
		position: relative;
	}
	.sk-navigation-link__icon-wrapper::before {
		content: ' ';
		display: block;
		height: 5px;
		background-color: #fff;
		width: 100%;
		position: absolute;
		left: 0;
		bottom: -5px;
		opacity: 0;
		transition: opacity 0.3s;
	}
	.sk-navigation-link__icon-wrapper.active::before {
		opacity: 1;
	}
	.sk-navigation-link__icon {
		display: block;
		width: 24px;
		height: 24px;
		margin: 15px;
		cursor: pointer;
		transition: transform 0.3s;
	}
	.sk-navigation-link__icon:hover {
		transform: scale(1.2, 1.2);
	}
	.label {
		position: absolute;
		top: 0;
		right: 0;
		border-radius: 100%;
		height: 20px;
		width: 20px;
		background-color: #F44336;
		color: var(--main-font-color-invert);
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/navigation/NavigationLinkIcon.vue